var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoMyob(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 30C0 13.4315 13.4315 0 30 0C46.5685 0 60 13.4315 60 30C60 46.5685 46.5685 60 30 60C13.4315 60 0 46.5685 0 30Z",
    fill: "#F2F5F8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9238 25.7904C13.1788 24.893 12.0444 24.3343 10.6392 24.3343C7.82857 24.3174 6 26.3153 6 28.9227V34.8994H6.86349C7.45608 34.8655 8.60741 34.5777 8.64127 32.8676V28.8719C8.64127 27.7036 9.45397 26.9079 10.6392 26.9079C12.3831 26.9079 12.5693 28.2962 12.5693 28.8719V34.8994H13.4328C14.0085 34.8655 15.1598 34.5777 15.2106 32.8846V28.8719C15.2106 27.7036 16.0571 26.9079 17.2085 26.9079C18.9524 26.9079 19.1556 28.2962 19.1556 28.8719V34.8994H20.019C20.6116 34.8655 21.7799 34.5777 21.7968 32.8338V28.9227C21.7968 26.2137 20.0868 24.3174 17.2085 24.3174C15.8709 24.3174 14.7026 24.893 13.9238 25.7904Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.416 25.7227L27.198 31.8856L24.7769 25.5026C24.4044 24.4867 23.4562 24.5544 23.4562 24.5544H21.3906L25.488 34.5777C25.488 34.5608 25.488 34.5608 25.471 34.5438C25.471 34.5438 25.471 34.5608 25.488 34.5777C25.488 34.5946 25.5049 34.6115 25.5049 34.6115L25.488 34.5608C25.6234 34.9671 25.5896 35.1872 25.4541 35.5936L25.3695 35.8475C24.8954 37.0327 24.2181 37.3544 22.7959 37.2697V37.2867L23.7779 39.7078C25.6065 39.674 26.9949 39.0645 27.9091 36.7787L32.8361 24.5544H30.9906C30.906 24.5544 29.8562 24.5883 29.416 25.7227Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7995 29.7692C34.7995 27.9915 35.9339 26.7386 37.3392 26.7386C38.7444 26.7386 39.8788 27.9745 39.8788 29.7692C39.8788 31.5132 38.7444 32.7153 37.3392 32.7153C35.9339 32.7153 34.7995 31.5132 34.7995 29.7692ZM32.1582 29.7523C32.1582 32.8338 34.4778 35.1364 37.3392 35.1364C40.2005 35.1364 42.537 32.8338 42.537 29.7523C42.537 26.6708 40.2005 24.3343 37.3392 24.3343C34.4778 24.3174 32.1582 26.6708 32.1582 29.7523Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0586 29.7693C46.0586 28.127 47.2438 26.8063 48.6999 26.8063C50.1559 26.8063 51.3411 28.0931 51.3411 29.7693C51.3411 31.4116 50.1559 32.6646 48.6999 32.6646C47.2438 32.6815 46.0586 31.3778 46.0586 29.7693ZM45.5168 20C43.7221 20 43.4343 21.219 43.4004 21.7947V34.8995H44.6702C45.6861 34.9164 45.9231 34.273 45.9401 33.9005V33.8497V33.7989C46.7358 34.6455 47.8364 35.1196 49.0893 35.1196C51.7983 35.1196 53.9993 32.8 53.9993 29.7524C53.9993 26.6878 51.7983 24.3683 49.0893 24.3683C47.9041 24.3683 46.8544 24.8085 46.0586 25.5704V20H45.5168Z",
    fill: "url(#paint3_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 6,
    y1: 29.8553,
    x2: 53.994,
    y2: 29.8553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#6100A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4557,
    stopColor: "#7001A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6409,
    stopColor: "#980293"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8947,
    stopColor: "#D9057E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#ED0677"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 6.00014,
    y1: 29.8553,
    x2: 53.9942,
    y2: 29.8553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#6100A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4557,
    stopColor: "#7001A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6409,
    stopColor: "#980293"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8947,
    stopColor: "#D9057E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#ED0677"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 5.99946,
    y1: 29.8553,
    x2: 53.9935,
    y2: 29.8553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#6100A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4557,
    stopColor: "#7001A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6409,
    stopColor: "#980293"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8947,
    stopColor: "#D9057E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#ED0677"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 5.99933,
    y1: 29.8554,
    x2: 53.9933,
    y2: 29.8554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#6100A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4557,
    stopColor: "#7001A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6409,
    stopColor: "#980293"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8947,
    stopColor: "#D9057E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#ED0677"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 19.7079,
    fill: "white",
    transform: "translate(6 20)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMyob);
export default __webpack_public_path__ + "static/media/logo_myob.6a6ae0a24a8af159313ceadbbe238655.svg";
export { ForwardRef as ReactComponent };